"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUEST_LOGGER = exports.LOGGER = void 0;
const constants_1 = require("../constants");
const window_1 = require("../utils/window");
const ClientLogger_1 = require("./logger/client/ClientLogger");
const loggerClass = (0, window_1.isClientSide)()
    ? ClientLogger_1.ClientLogger
    :
        require('./logger/server/ServerLogger').ServerLogger;
exports.LOGGER = new loggerClass(`${constants_1.ENV_APP_PREFIX}/application_log`);
exports.REQUEST_LOGGER = new loggerClass(`${constants_1.ENV_APP_PREFIX}/request_log`);
